<template>
  <div class="frame">
    <h2 class="login">Login</h2>
    <form @submit.prevent="checkUser">
      <div class="search">
        <label for="email" class="searchfield">Email</label>
        <div>
          <input type="email" name="email" id="email" class="button" v-model="email" />
        </div>
      </div>

      <div class="search">
        <label for="password" class="searchfield">Password</label>
        <input type="password" name="password" id="password" class="button" v-model="password" />
      </div>

      <div>
        <button type="submit" class="login-button" @click="checkUser">Login</button>
      </div>
    </form>
  </div>
</template>


<script>
export default {
  name: "Login",

  data() {
    return {
      email: "",
      password: ""
    };
  },

  methods: {
    checkUser() {
      if (this.email != "" && this.password != "") {
        this.$store
          .dispatch("checkUser", {
            email: this.email,
            password: this.password
          })
          .then(() => {})
          .catch(err => {
            console.log(err);
            localStorage.setItem("loggeduser", "false");
            this.$router.push("/login");
          });
        this.email = "";
        this.password = "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import url(https://fonts.googleapis.com/css?family=Open+Sans:600);

.login-form {
  position: relative;
  top: 10px;
}
.search {
  margin-top: 0px;

  .searchfield {
    border-radius: 0;
    font-size: 13px;
    font-weight: 100;
    padding: 0 0 0 15px;
    border: 0;
    display: inline-block;
    max-width: 100%;
    margin-bottom: 5px;
    font-weight: 700;
    margin-left: 25px;
    margin-top: 20px;
    font-size: 25px;
  }
  .button {
    border: 1px solid rgba(0, 0, 0, 0.2);
    width: 300px;
    border-radius: 5px;
    background: #fff;
    color: #5ca4ea;
    font-size: 18px;
    padding: 10px;
    left: 10px;
    outline: 0;
    max-width: 100%;
    margin-left: 35px;
  }
}

.login-button {
  background: #fff;
  color: #5ca4ea;
  display: block;
  width: 150px;
  height: 50px;
  border-radius: 25px;
  text-align: center;
  line-height: 46px;
  text-transform: uppercase;
  font-weight: 600;
  box-sizing: border-box;
  border-radius: 25px;
  margin-top: 15px;
  margin-left: 120px;
  border-style: none;
}

.login {
  margin-left: 10%;
  font-weight: bold;
  margin-top: 12%;
  font-size: 40px;
  margin-bottom: 0px;
}
.frame {
  position: absolute;
  width: 400px;
  height: 400px;
  top: 40%;
  left: 50%;
  margin: -200px 0 0 -200px;
  border-radius: 2px;
  box-shadow: 1px 2px 10px 0 rgba(0, 0, 0, 0.3);
  overflow: hidden;
  background: #5ca4ea;
  color: #fff;
  font-family: "Open sans", Helvetica, sans-serif;
}
</style>